import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const yesItems = ['Tenés un hijo de 8 a 11 años con dificultades en matemáticas', 'Querés ayudarlo pero no sabés por dónde empezar', 'Las sesiones de tarea terminan en tensión o llanto', 'Entiende un día y al siguiente lo olvidó todo', 'Necesitás un sistema claro de 10 minutos por día', 'No querés volver a perder la paciencia en la tarea'];
const noItems = ['Buscás un curso teórico de matemáticas para adultos', 'No te interesa seguir un protocolo ni sistematizar', 'Creés que lo tiene que resolver el colegio solo', 'Pensás que las dificultades se van a resolver con el tiempo', 'No querés dedicar 10 minutos al día a acompañar a tu hijo', 'Buscás una solución mágica sin involucrarte en el proceso'];
export function IsForYou() {
  const rowCount = Math.max(yesItems.length, noItems.length);
  return <section className="py-14 md:py-20 bg-white border-t border-slate-200" aria-label="¿Es para vos?" data-id="element-188">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-189">
        <FadeIn data-id="element-190">
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-slate-900 text-center mb-10" data-id="element-191">
            ¿ESTE SISTEMA ES PARA VOS?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-192">
          <div className="rounded-3xl border border-slate-200 overflow-hidden shadow-soft-lg" data-id="element-193">
            <table className="w-full table-fixed border-collapse" data-id="element-194">
              <colgroup data-id="element-195">
                <col className="w-1/2" data-id="element-196" />
                <col className="w-1/2" data-id="element-197" />
              </colgroup>
              <thead data-id="element-198">
                <tr data-id="element-199">
                  <th scope="col" className="bg-primary/10 border-b border-primary/20 px-3 py-4 md:px-6 md:py-5 text-left" data-id="element-200">
                    <span className="flex items-center gap-2 font-heading text-sm md:text-lg font-extrabold text-primary-dark" data-id="element-201">
                      <CheckIcon className="w-5 h-5 shrink-0" aria-hidden="true" data-id="element-202" />
                      SÍ es para vos
                    </span>
                  </th>
                  <th scope="col" className="bg-coral/10 border-b border-l border-coral/20 px-3 py-4 md:px-6 md:py-5 text-left" data-id="element-203">
                    <span className="flex items-center gap-2 font-heading text-sm md:text-lg font-extrabold text-coral-dark" data-id="element-204">
                      <XIcon className="w-5 h-5 shrink-0" aria-hidden="true" data-id="element-205" />
                      NO es para vos
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-206">
                {Array.from({
                length: rowCount
              }).map((_, i) => <tr key={i} className="align-top" data-id="element-207">
                    <td className="bg-primary/[0.03] px-3 py-3 md:px-6 md:py-4" data-id="element-208">
                      {yesItems[i] && <span className="flex items-start gap-2.5 text-slate-700 text-sm md:text-base font-medium leading-snug" data-id="element-209">
                          <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-primary shrink-0 mt-0.5" aria-hidden="true" data-id="element-210" />
                          {yesItems[i]}
                        </span>}
                    </td>
                    <td className="border-l border-slate-100 bg-coral/[0.03] px-3 py-3 md:px-6 md:py-4" data-id="element-211">
                      {noItems[i] && <span className="flex items-start gap-2.5 text-slate-700 text-sm md:text-base font-medium leading-snug" data-id="element-212">
                          <XIcon className="w-4 h-4 md:w-5 md:h-5 text-coral shrink-0 mt-0.5" aria-hidden="true" data-id="element-213" />
                          {noItems[i]}
                        </span>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </FadeIn>
      </div>
    </section>;
}